require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-sanitize/index.js
// module id = 447
// module chunks = 0